<div class="lexbe-toolbar" style="display: flex;">
  <div style="display: flex; align-items: center;">
      <button *ngIf="isSectionActive('review')" (click)="hideShow()" color="primary" mat-button style="height: 100%; padding: 0;">
        @if(hideShowService.show){
          <div style="height: 55px;" class="hide-show-button">
            <span class="fal fa-sidebar"></span>
            <span style="width: 100px;">Hide Sidebar</span>
          </div>
        } @else {
          <div style="height: 55px;" class="hide-show-button">
            <span class="fal fa-sidebar"></span>
            <span style="width: 100px;">Show Sidebar</span>
          </div>
        }
      </button>
    <button class="notification-button" mat-button color="primary" [matMenuTriggerFor]="menuProcessingNotifications" style="height: 100%; padding: 0;">
      <span class="fa-stack fa-2x">
        <span class="fa-light fa-bell fa-stack-1x" style="font-size: 17px; line-height: 55px;;"></span>
        <span *ngIf="isProcessing || processingSteps?.length > 0" class="fa-solid fa-circle fa-stack-2x"
           style="font-size: 5px; padding-top: 21px; padding-left: 4px;"></span>
      </span>
    </button>
  </div>
  <div style="display: flex; align-content: center;">
    <button mat-button color="primary" style="display: flex; align-items: center; justify-content: flex-start; height: 55px; max-width: 370px;"
      [matMenuTriggerFor]="menuCurrentCase" [attr.matTooltip]="currentCaseTooltip">
      <div style="display: inline-flex;">
        <span class="fa-light fa-circle-user" color="primary" style="padding-right: 16px; font-size: 16px;"></span>
        <span class="case-name-dropdown ellipsis" style="max-width: 270px;">{{currentCaseName}}</span>
        <div class="fal fa-chevron-down" style="padding-left: 16px;"></div>
      </div>
    </button>
  </div>
</div>

<mat-menu #menuProcessingNotifications class="processing-notifications-menu">
  <div class="processing-item" style="height: initial;" *ngFor="let processingStep of processingSteps" mat-menu-item>
    {{processingStep.executionState}}
    <lex-processing-item [item]="processingStep"></lex-processing-item>
  </div>
  <div style="margin-top: 4px;">
    <label *ngIf="isProcessing || processingSteps?.length > 0" class="notification-checkbox-container" mat-menu-item>
      <mat-checkbox class="notification-checkbox" (change)="notifyOnProcessingComplete($event)" [checked]="shouldNotify">
        Notify me when processing is complete
      </mat-checkbox>
    </label>
    <label *ngIf="!isProcessing && processingSteps?.length === 0" class="no-processing-steps-active lex-theme-font--classic fontify-12px" mat-menu-item>
      No queued steps processing at this time.
    </label>
  </div>

</mat-menu>

<mat-menu #menuCurrentCase="matMenu" class="customize-mat-menu" xPosition="before">
  <span mat-menu-item class="current-user-button" style="cursor:default; background: transparent;">
    <span id="current-case-icon" class="fal fa-city" style="padding-right: 10px; font-size: 24px; "></span>
    {{currentCase?.account?.accountName}}
  </span>
  <mat-divider></mat-divider>
  <div class="theme-toggle" style="padding: 0 16px; display: flex; align-items: center; line-height: 48px; height: 48px;" (click)="$event.stopPropagation()">
    <mat-icon style="margin-right:4px;" *ngIf="!isDarkTheme" color="accent">light_mode</mat-icon>
    <mat-icon style="margin-right:4px;" *ngIf="isDarkTheme">light_mode</mat-icon>
    <mat-slide-toggle #darkModeSwitch [(ngModel)]="isDarkTheme" (change)="toggleTheme($event)" [hideIcon]="true">
    </mat-slide-toggle>
    <mat-icon *ngIf="isDarkTheme" color="accent">dark_mode</mat-icon>
    <mat-icon *ngIf="!isDarkTheme">dark_mode</mat-icon>
  </div>
  <a routerLink="/select-case" mat-menu-item class="change_current_case_button">
    <span class="fa-light fa-arrow-right-arrow-left" style="padding-right: 13px; font-size: 18px;"></span>
    Change current case
  </a>
  <a [href]="helpLink" mat-menu-item class="help_button" target="_blank">
    <span class="fa-light fa-circle-question" style="padding-right: 13px; font-size: 18px;"></span>
    Help
  </a>
  <a [href]="supportLink" mat-menu-item class="support_button" target="_blank">
    <span class="fa-light fa-comments-question" style="padding-right: 10px; font-size: 18px;"></span>
    Support
  </a>
  <mat-divider></mat-divider>
  <button mat-menu-item class="logout-button" (click)="logout()">
    <span class="fa-light fa-right-from-bracket" style="padding-right: 5px; font-size: 18px;"></span>
    {{getLogoutText()}}
  </button>
</mat-menu>
